import { render } from "./ReportesView.vue?vue&type=template&id=1c38ba0e&scoped=true"
import script from "./ReportesView.vue?vue&type=script&lang=js"
export * from "./ReportesView.vue?vue&type=script&lang=js"

import "./ReportesView.vue?vue&type=style&index=0&id=1c38ba0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c38ba0e"]])

export default __exports__